// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierWiseAPIPurchaseConsumptionPage_inputContainer__3tAwV"};